// import React, { useState } from "react";
// import {
//   Modal,
//   Box,
//   Paper,
//   Typography,
//   IconButton,
//   Container,
//   Grid,
//   TextField,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   FormLabel,
//   Card,
//   CardContent,
//   Divider,
//   Tooltip,
//   MenuItem,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import CloseIcon from "@mui/icons-material/Close";
// import { useDispatch } from "react-redux";
// import { message } from "antd";
// import { QRCodeCanvas } from "qrcode.react";
// import CustomButton from "./CustomButton";
// import { createAdmission } from "../redux/actions/admissionActions";

// const AdmissionModal = ({ open, onClose }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();

//   const [form, setForm] = useState({
//     studentName: "",
//     fatherName: "",
//     motherName: "",
//     birthDate: "",
//     gender: "Male",
//     presentDivision: "",
//     presentDistrict: "",
//     presentAddress: "",
//     permanentDivision: "",
//     permanentDistrict: "",
//     permanentAddress: "",
//     phone: "",
//     email: "",
//     courseName: "",
//     className: "",
//   });

//   const [transactionId, setTransactionId] = useState("");
//   const [paymentSubmitting, setPaymentSubmitting] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [openPaymentModal, setOpenPaymentModal] = useState(false);
//   const [copied, setCopied] = useState(false);

//   const totalFees = 7000;
//   const upiId = "msola33052@ybl";

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCopy = () => {
//     navigator.clipboard.writeText(upiId);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1500);
//   };

//   const validateForm = () => {
//     const requiredFields = [
//       "studentName",
//       "fatherName",
//       "motherName",
//       "birthDate",
//       "phone",
//       "email",
//     ];

//     const errors = [];

//     requiredFields.forEach((field) => {
//       if (!form[field]?.trim()) {
//         const fieldNames = {
//           studentName: "Student Name",
//           fatherName: "Father's Name",
//           motherName: "Mother's Name",
//           birthDate: "Date of Birth",
//           phone: "Phone Number",
//           email: "Email Address"
//         };
//         errors.push(`${fieldNames[field]} is required`);
//       }
//     });

//     if (!form.className?.trim() && !form.courseName?.trim()) {
//       errors.push("Please select either Class Name or Course Name");
//     }

//     if (form.phone && !/^\d{10}$/.test(form.phone)) {
//       errors.push("Phone number must be 10 digits");
//     }

//     if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
//       errors.push("Please enter a valid email address");
//     }

//     return errors;
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const validationErrors = validateForm();

//     if (validationErrors.length > 0) {
//       validationErrors.forEach((error) => message.error(error));
//       setLoading(false);
//       return;
//     }

//     setOpenPaymentModal(true);
//     setLoading(false);
//   };

//   const handlePaymentConfirm = () => {
//     if (!transactionId.trim()) {
//       message.error("Please enter Transaction ID");
//       return;
//     }

//     setPaymentSubmitting(true);

//     const admissionData = {
//       ...form,
//       transactionId: transactionId.trim(),
//       totalFees: totalFees.toString(),
//       paymentStatus: "Pending",
//       paymentDate: new Date().toISOString().split("T")[0],
//     };

//     dispatch(createAdmission(admissionData))
//       .then(() => {
//         message.success("Admission submitted successfully!");
//         setForm({
//           studentName: "",
//           fatherName: "",
//           motherName: "",
//           birthDate: "",
//           gender: "Male",
//           presentDivision: "",
//           presentDistrict: "",
//           presentAddress: "",
//           permanentDivision: "",
//           permanentDistrict: "",
//           permanentAddress: "",
//           phone: "",
//           email: "",
//           courseName: "",
//           className: "",
//         });
//         setTransactionId("");
//         setOpenPaymentModal(false);
//         onClose(); // Close the main modal after successful submission
//       })
//       .catch((error) => {
//         message.error("Failed to submit admission. Please try again.");
//       })
//       .finally(() => {
//         setPaymentSubmitting(false);
//       });
//   };

//   return (
//     <>
//       {/* Main Admission Modal */}
//       <Modal
//         open={open}
//         onClose={onClose}
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           p: { xs: 1, sm: 2 },
//         }}
//       >
//         <Paper
//           sx={{
//             width: "100%",
//             maxWidth: "lg",
//             maxHeight: "90vh",
//             overflow: "auto",
//             borderRadius: 3,
//             position: "relative",
//           }}
//         >
//           <Box
//             sx={{
//               position: "sticky",
//               top: 0,
//               bgcolor: "white",
//               zIndex: 10,
//               p: 2,
//               borderBottom: "1px solid #ddd",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <Typography variant="h5" sx={{ fontWeight: "bold", color: "#065A79" }}>
//               🎓 Admission Form - Shree Mangalam School
//             </Typography>
//             <IconButton onClick={onClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
          
//           <Container sx={{ py: 4 }}>
//             <Typography
//               variant="body1"
//               sx={{
//                 mb: 3,
//                 fontFamily: "Montserrat, sans-serif",
//                 fontOpticalSizing: "auto",
//                 fontStyle: "normal",
//                 letterSpacing: 1,
//                 lineHeight: "1.8rem",
//                 color: "#555",
//               }}
//             >
//               Welcome! Please fill out the admission form below to apply. After submission, 
//               you will be directed to the payment page to complete your admission process.
//             </Typography>

//             <form onSubmit={handleFormSubmit}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     fullWidth
//                     label="Student's Name"
//                     name="studentName"
//                     value={form.studentName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     fullWidth
//                     label="Father's Name"
//                     name="fatherName"
//                     value={form.fatherName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     fullWidth
//                     label="Mother's Name"
//                     name="motherName"
//                     value={form.motherName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Birth Date"
//                     name="birthDate"
//                     type="date"
//                     value={form.birthDate}
//                     onChange={handleChange}
//                     InputLabelProps={{ shrink: true }}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box display="flex" alignItems="center" sx={{ mt: 2 }}>
//                     <FormLabel sx={{ mr: 2 }}>Gender</FormLabel>
//                     <RadioGroup
//                       row
//                       name="gender"
//                       value={form.gender}
//                       onChange={handleChange}
//                     >
//                       <FormControlLabel value="Male" control={<Radio />} label="Male" />
//                       <FormControlLabel value="Female" control={<Radio />} label="Female" />
//                     </RadioGroup>
//                   </Box>
//                 </Grid>

//                 {/* Present Address */}
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" sx={{ color: "#AD1C86", fontWeight: 600 }}>
//                     Present Address
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="Division" name="presentDivision" value={form.presentDivision} onChange={handleChange} />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="District" name="presentDistrict" value={form.presentDistrict} onChange={handleChange} />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField fullWidth multiline minRows={2} label="Address" name="presentAddress" value={form.presentAddress} onChange={handleChange} />
//                 </Grid>

//                 {/* Permanent Address */}
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" sx={{ color: "#AD1C86", fontWeight: 600 }}>
//                     Permanent Address
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="Division" name="permanentDivision" value={form.permanentDivision} onChange={handleChange} />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="District" name="permanentDistrict" value={form.permanentDistrict} onChange={handleChange} />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField fullWidth multiline minRows={2} label="Address" name="permanentAddress" value={form.permanentAddress} onChange={handleChange} />
//                 </Grid>

//                 {/* Contact Info */}
//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="Phone Number" name="phone" value={form.phone} onChange={handleChange} required />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="Email Address" name="email" value={form.email} onChange={handleChange} required />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <TextField fullWidth label="Class Name" name="className" value={form.className} onChange={handleChange} />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <TextField select fullWidth label="Select Course" name="courseName" value={form.courseName} onChange={handleChange}>
//                     <MenuItem value="">Select a course</MenuItem>
//                     <MenuItem value="Navodaya">Navodaya Vidyalaya Preparation</MenuItem>
//                     <MenuItem value="RIMC">RIMC (Rashtriya Indian Military College)</MenuItem>
//                     <MenuItem value="Sainik">Sainik School</MenuItem>
//                     <MenuItem value="Military">Military School</MenuItem>
//                     <MenuItem value="Other">Other</MenuItem>
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
//                   <CustomButton
//                     ButtonName={loading ? "Validating..." : "Proceed to Payment"}
//                     type="submit"
//                     disabled={loading}
//                     handleSubmit={handleFormSubmit}
//                   />
//                   <Typography variant="caption" sx={{ display: "block", mt: 1, color: "#666" }}>
//                     * Required fields must be filled
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </form>
//           </Container>
//         </Paper>
//       </Modal>

//       {/* Payment Modal */}
//       <Modal
//         open={openPaymentModal}
//         onClose={() => setOpenPaymentModal(false)}
//         sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
//       >
//         <Card sx={{ maxWidth: 450, width: "100%", borderRadius: 3, p: 3 }}>
//           <Box sx={{ textAlign: "center", mb: 2 }}>
//             <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//               Payment Required
//             </Typography>
//             <Typography variant="subtitle1">
//               Please complete the payment to submit your admission
//             </Typography>
//           </Box>

//           <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//             <Typography variant="h6" sx={{ mb: 2 }}>
//               Total Amount: ₹{totalFees}
//             </Typography>

//             <Typography variant="body2" sx={{ mb: 2, textAlign: "center" }}>
//               Scan QR code using any UPI app or copy UPI ID below
//             </Typography>

//             <Box sx={{ p: 2, border: `2px dashed ${theme.palette.divider}`, borderRadius: 2, mb: 2 }}>
//               <QRCodeCanvas
//                 value={`upi://pay?pa=${upiId}&pn=ShreeMangalamSchool&am=${totalFees}&cu=INR&tn=Admission%20Fees%20for%20${encodeURIComponent(form.studentName)}`}
//                 size={220}
//                 level="H"
//                 includeMargin={true}
//               />
//             </Box>

//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//               <Typography variant="body2">
//                 UPI ID: <strong>{upiId}</strong>
//               </Typography>
//               <Tooltip title={copied ? "Copied!" : "Copy UPI ID"}>
//                 <IconButton size="small" onClick={handleCopy}>
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Tooltip>
//             </Box>

//             <Typography variant="caption" sx={{ color: "text.secondary", mb: 2, textAlign: "center" }}>
//               After payment, please enter the transaction ID below
//             </Typography>

//             <TextField
//               label="Transaction ID *"
//               value={transactionId}
//               onChange={(e) => setTransactionId(e.target.value)}
//               fullWidth
//               sx={{ mt: 2 }}
//               required
//               placeholder="Enter UPI transaction ID"
//             />

//             <Divider sx={{ width: "100%", my: 2 }} />

//             <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
//               <CustomButton
//                 ButtonName="Cancel"
//                 variant="outlined"
//                 fullWidth
//                 handleSubmit={() => setOpenPaymentModal(false)}
//               />
//               <CustomButton
//                 ButtonName={paymentSubmitting ? "Submitting..." : "Confirm Payment"}
//                 disabled={!transactionId.trim() || paymentSubmitting}
//                 fullWidth
//                 handleSubmit={handlePaymentConfirm}
//               />
//             </Box>
//           </CardContent>
//         </Card>
//       </Modal>
//     </>
//   );
// };

// export default AdmissionModal;


import React from "react";
import {
  Modal,
  Box,
  Card,
  CardMedia,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import admissionImage from "../assets/AdmissionModel.jpeg";
import CustomButton from './CustomButton';

const AdmissionModal = ({ open, onClose }) => {
  const handleNavigate = () => {
    onClose();
    window.location.href = "/admission-form";
  };
  
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "95vw",
          maxWidth: "750px",
          height: "95vh",
          maxHeight: "700px",
          backgroundColor: "white",
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 10,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            "&:hover": {
              backgroundColor: "white",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Image Container - Takes most space */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            p: 2,
          }}
        >
          <CardMedia
            component="img"
            image={admissionImage}
            alt="Admission Open"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              maxHeight: "100%",
            }}
          />
        </Box>

        {/* Button Section - Fixed at bottom */}
        <Box
          sx={{
            // padding: 3,
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid #e0e0e0",
            textAlign: "center",
          }}
        >
          {/* <Button
            onClick={handleNavigate}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#065A79",
              color: "white",
              fontSize: "1.1rem",
              fontWeight: "bold",
              padding: "12px 50px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                backgroundColor: "#054761",
                transform: "scale(1.05)",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.3)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Apply for Admission
          </Button> */}
          <CustomButton ButtonName={"Apply for Admission"}  handleSubmit={handleNavigate}/>
          
          <Box
            component="p"
            sx={{
              mt: 1,
              fontSize: "0.875rem",
              color: "#666",
            }}
          >
            Click to fill the admission form
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AdmissionModal;